import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DossierHistoriqueComponent } from "./dossier-historique/dossier-historique.component";
import { CreateDossierCreditComponent } from "./formulaire/createform/create-dossier-credit/create-dossier-credit.component";
import { DossierInfoComponent } from "./dossier-info/dossier-info.component";
import { DossierUpdateComponent } from "./dossier-update/dossier-update.component";
import { UpdateDossierInfoComponent } from "./dossier-update/form/update-dossier-info/update-dossier-info.component";
import { BniCreateDossierCreditComponent } from "./formulaire/createform/bni-create-dossier-credit/bni-create-dossier-credit.component";
import { FormScanPieceComponent } from "./formulaire/taskform/form-scan-piece/form-scan-piece.component";
import { FormulaireLayoutComponent } from "./formulaire/formulaire-layout/formulaire-layout.component";
import { FormAjouterRapportAnalyseComponent } from "../formulaire/form/form-ajouter-rapport-analyse/form-ajouter-rapport-analyse.component";
import { FormAnalyseDossierComponent } from "../formulaire/form/form-analyse-dossier/form-analyse-dossier.component";
import { FormAffectationDossierComponent } from "../formulaire/form/form-affectation-dossier/form-affectation-dossier.component";
import { FormEmissionAvisDossierComponent } from "../formulaire/form/form-emission-avis-dossier/form-emission-avis-dossier.component";
import { FormMiseEnPlaceCreditComponent } from "./formulaire/taskform/form-mise-en-place-credit/form-mise-en-place-credit.component";
import { FormAnalyseDossierEmissionAvisComponent } from "../formulaire/form/form-analyse-dossier-emission-avis/form-analyse-dossier-emission-avis.component";
import { DossierHistoriqueNewComponent } from "./dossier-historique-new/dossier-historique-new.component";
import { FormSignerRapportAnalyseComponent } from "../formulaire/form/form-signer-rapport-analyse/form-signer-rapport-analyse.component";
import { FormPreparationComiteInterneCreditComponent } from "../formulaire/form/form-preparation-comite-interne-credit/form-preparation-comite-interne-credit.component";
import { FormAjoutGarantieComponent } from "../formulaire/form/form-ajout-garantie/form-ajout-garantie.component";
import { FormCommentaireSimpleComponent } from '../formulaire/form/form-commentaire-simple/form-commentaire-simple.component';
import { FormEmissionAccordDossierComponentComponent } from '../formulaire/form/form-emission-accord-dossier-component/form-emission-accord-dossier-component.component';
import { FormAjoutRapportEmissionAvisComponent } from '../formulaire/form/form-ajout-rapport-emission-avis/form-ajout-rapport-emission-avis.component';
import { FormSignerRapportEmissionAvisComponent } from '../formulaire/form/form-signer-rapport-emission-avis/form-signer-rapport-emission-avis.component';
import { DossierHistoriqueAllComponent } from './dossier-historique-all/dossier-historique-all.component';

const routes: Routes = [
  //
  {
    path: "",
    data: { breadcrumb: "Particulier" },
    children: [
      {
        path: "",
        redirectTo: "dossier-historique",
        pathMatch: "full",
      },
      {
        path: "dossier-historique",
        component: DossierHistoriqueComponent,
        data: { breadcrumb: "Historique dossier" },
      },
      {
        path: "dossier-historique-new",
        component: DossierHistoriqueNewComponent,
        data: { breadcrumb: "Historique dossier" },
      },

      {
        path: 'dossier-historique-all',
        component: DossierHistoriqueAllComponent,
        data: {breadcrumb: 'Historique dossier'},
      },
      {
        path: 'dossier-historique-all/:status/:startDate/:endDate',
        component: DossierHistoriqueAllComponent,
        data: {breadcrumb: 'Historique dossier'},
      },

      //
      {
        path: "create-dossier-credit/:workflowCode",
        component: CreateDossierCreditComponent,
        data: { breadcrumb: "Créer un dossier de crédit" },
      },
      {
        path: "bni-create-dossier-credit/:workflowCode",
        component: BniCreateDossierCreditComponent,
        data: { breadcrumb: "Créer un dossier de crédit" },
      },
      //

      // pour renouvellement
      {
        path: "create-dossier-credit/:workflowCode/:requestIdParent",
        component: CreateDossierCreditComponent,
        data: { breadcrumb: "Créer un dossier de crédit" },
      },
      {
        path: "bni-create-dossier-credit/:workflowCode/:requestIdParent",
        component: BniCreateDossierCreditComponent,
        data: { breadcrumb: "Créer un dossier de crédit" },
      },
      //

      {
        path: "dossier-info/:requestId",
        component: DossierInfoComponent,
        data: { breadcrumb: "Dossier Info" },
      },

      {
        path: "form-scan-piece/:requestId/:taskId",
        data: { breadcrumb: "Formulaire" },
        component: FormScanPieceComponent,
      },
    ],
  },
  //

  //
  {
    path: "",
    data: { breadcrumb: "Product Program" },
    component: DossierUpdateComponent,
    children: [
      {
        path: "dossier-update/:requestId/:correctionId",
        data: { breadcrumb: "Formulaire" },
        component: UpdateDossierInfoComponent,
      },
    ],
  },
  //

  {
    path: "",
    data: { breadcrumb: "Product Program" },
    component: FormulaireLayoutComponent,
    children: [
      {
        path: "form-ajout-garantie/:requestId/:taskId",
        data: { breadcrumb: "Formulaire" },
        component: FormAjoutGarantieComponent,
      },
      {
        path: "form-ajouter-rapport-analyse/:requestId/:taskId",
        component: FormAjouterRapportAnalyseComponent,
      },
      {
        path: "form-analyse-dossier/:requestId/:taskId",
        component: FormAnalyseDossierComponent,
      },
      {
        path: "form-affectation-dossier/:requestId/:taskId",
        component: FormAffectationDossierComponent,
      },
      {
        path: "form-emission-avis-dossier/:requestId/:taskId",
        component: FormEmissionAvisDossierComponent,
      },
      {
        path: "form-analyse-dossier-emission-avis/:requestId/:taskId",
        component: FormAnalyseDossierEmissionAvisComponent,
      },
      {
        path: "form-validation-garantie/:requestId/:taskId",
        component: FormAjouterRapportAnalyseComponent,
      },
      {
        path: "form-deblocage-fonds/:requestId/:taskId",
        component: FormMiseEnPlaceCreditComponent,
      },
      {
        path: "form-verification-dossier-credit/:requestId/:taskId",
        component: FormAnalyseDossierComponent,
      },
      {
        path: "form-signer-rapport-analyse/:requestId/:taskId",
        component: FormSignerRapportAnalyseComponent,
      },
      {
        path: "form-signer-rapport-analyse-emission-avis/:requestId/:taskId",
        component: FormSignerRapportEmissionAvisComponent,
      },
      {
        path: "form-credit-info-volo/:requestId/:taskId",
        component: FormAjouterRapportAnalyseComponent,
      },
      {
        path: "form-verification-avis-dossier/:requestId/:taskId",
        component: FormAnalyseDossierEmissionAvisComponent,
      },
      {
        path: "form-affectation-dossier-chef-serv-admin-credit/:requestId/:taskId",
        component: FormAffectationDossierComponent,
      },
      {
        path: "form-affectation-dir-jur/:requestId/:taskId",
        component: FormAffectationDossierComponent,
      },
      {
        path: "form-affectation-chef-dep-gar/:requestId/:taskId",
        component: FormAffectationDossierComponent,
      },
      {
        path: "form-verification-garantie/:requestId/:taskId",
        component: FormAjoutRapportEmissionAvisComponent,
      },
      {
        path: "form-validation-garantie/:requestId/:taskId",
        component: FormEmissionAvisDossierComponent,
      },
      {
        path: "form-validation-dossier/:requestId/:taskId",
        component: FormEmissionAvisDossierComponent,
      },
      {
        path: "form-preparation-comite-interne-credit/:requestId/:taskId",
        component: FormPreparationComiteInterneCreditComponent,
      },
      {
        path: "form-envois-avis-comite-credit/:requestId/:taskId",
        component: FormEmissionAccordDossierComponentComponent,
      },
      { 
        path: 'form-commentaire-simple/:requestId/:taskId', 
        component: FormCommentaireSimpleComponent
      },
      { 
        path: 'form-signature-lettre-offre/:requestId/:taskId', 
        component: FormSignerRapportAnalyseComponent
      },
      { 
        path: 'form-analyse-financiere-risque/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },
      { 
        path: 'form-verification-validation-garantie-analyste-credit/:requestId/:taskId',
        component: FormAjouterRapportAnalyseComponent
      },
      { 
        path: 'form-mise-en-place-garantie-si/:requestId/:taskId', 
        component: FormCommentaireSimpleComponent
      },
      { 
        path: 'form-notifier-client-deblocage-fonds/:requestId/:taskId', 
        component: FormCommentaireSimpleComponent
      },
      { 
        path: 'form-generation-lettre-offre-convention-credit/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },

    ]
  }
  //
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ParticulierRoutingModule {}
